import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { PatientPortalService } from '../patient-portal.service';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { DOCUMENT_TAG } from 'src/app/models/constants/document-tag.model';

@Component({
  selector: 'app-patient-portal-insurance',
  templateUrl: './patient-portal-insurance.component.html',
  styleUrls: ['./patient-portal-insurance.component.css']
})
export class PatientPortalInsuranceComponent implements OnInit {

  @Input() disableSaveButton: boolean = false;
  @Input() PatientId: string;
  @Input() imageViewWidth: number = 0;
  @Input() useImageViewWidth: boolean = false;

  cardObj: any;
  tmpCardObj: any = {};
  isLoading: boolean = false;  

  documentGroup: any;
  documentParentObjectName: string = "dataINFGrInsulranceCard";
  DOCUMENT_TAG: DOCUMENT_TAG;
  @ViewChild('imageView') imageView: any;

  constructor(
    private infoService: PatientPortalService,
    private fileService: FileManagerService,
  ) {    
    this.DOCUMENT_TAG = DOCUMENT_TAG;
  }

  ngOnInit() {
    this.isLoading = true;
    this.getPatientInsuranceCard()
      .then((card: any) => {
        //console.log("getPatientInsuranceCard", card);
        this.cardObj = card;
        if (!card.InsuranceCardInfo  || card.InsuranceCardInfo === "") {
          this.tmpCardObj = {
            InsuranceHasInsurance: false,
            InsuranceCompanyName: '',
            InsuranceAddress: '',
            InsurancePhone: '',
            InsuranceGroup: '',
            InsuranceID: '',
            InsuranceEmployer: '',
            SubscriberName: '',
            SubscriberSSN: '',
            SubscriberDOB: '',
          };
        } else {
          this.tmpCardObj = JSON.parse(card.InsuranceCardInfo);
          if (typeof this.tmpCardObj.InsuranceHasInsurance == "undefined") {
            this.tmpCardObj.InsuranceHasInsurance = false;
          }

          if (typeof this.tmpCardObj.SubscriberName == "undefined") {
            this.tmpCardObj.InsuranceHasInsurance = '';
          }

          if (typeof this.tmpCardObj.SubscriberSSN == "undefined") {
            this.tmpCardObj.InsuranceHasInsurance = '';
          }

          if (typeof this.tmpCardObj.SubscriberDOB == "undefined") {
            this.tmpCardObj.InsuranceHasInsurance = '';
          }

        }

        this.getDocumentGroupByType()
          .then((documentGroups: any[]) => {

            if (documentGroups.length) {
              this.documentGroup = documentGroups[0];
              this.isLoading = false;
            } else {
              this.createDocumentGroup()
                .then((documentGroup: any) => {
                  this.documentGroup = documentGroup;
                  this.isLoading = false;                  
                }, err => {
                  this.isLoading = false;
                });
            }

          }, err => {
            this.isLoading = false;
          });

      }, err => {
        this.isLoading = false;
      });
  }

  getFileViewWidth() {

    if (this.useImageViewWidth) {
      return this.imageViewWidth - 50;
    }

    try {
      var imageViewSize = document.getElementById('mainInsuranceContainer').offsetWidth;
      return imageViewSize;
    } catch (err) {
      console.log('ERROR', err);
      return 0;
    }    
  }

  activateImageView() {
    this.imageView.handleUploadClicked();
  }

  getDocumentGroupByType() {
    let promise = new Promise((resolve, reject) => {
      this.fileService.getDocumentGroupByObjectId(this.PatientId, this.cardObj.InfGrInsuranceID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  createDocumentGroup() {
    let promise = new Promise((resolve, reject) => {
      var creationObj = {
        ParentObjectName: this.documentParentObjectName,
        ObjectId: this.cardObj.InfGrInsuranceID,
        PatientId: this.PatientId,
        documentIds: [],
      };
      this.fileService.createDocumentGroup(creationObj)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  public saveFromAllWindows() {
    let promise = new Promise((resolve, reject) => {
      this.savePatientInsuranceCard()
        .then(resolve, reject);
    });
    return promise;
  }

  onSavePressed() {
    this.isLoading = true;
    this.savePatientInsuranceCard()
      .then((result) => {
        console.log(result);
        this.isLoading = false;
      }, err => {
        console.log(err);
        this.isLoading = false;
      });
  }

  getPatientInsuranceCard() {
    
    console.log("PatientPortalInsuranceComponent getPatientInsuranceCard", this.PatientId);
    let promise = new Promise((resolve, reject) => {
      this.infoService.getPatientInsuranceCard(this.PatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  savePatientInsuranceCard() {
    let promise = new Promise((resolve, reject) => {
      var infoString = JSON.stringify(this.tmpCardObj);
      this.cardObj.InsuranceCardInfo = infoString;
      this.infoService.savePatientInsuranceCard(this.PatientId, this.cardObj)
        .subscribe(resolve, reject);
    });
    return promise;
  }

}
